/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * Schema for creating batch DIDComm messages.
 */
export interface DidCommMessageCreateBlobs {
    messages: Truvity.DidCommMessageBlobDescriptor[];
}
